const GDPR_GTM_COOKIE_BANNER = "gatsby-gdpr-google-tagmanager";

module.exports = {
  GDPR_GTM_COOKIE_BANNER,
};
